import React from "react";
import { Pagination } from "react-bootstrap";

function BuildPagination({ numberOfPages, methodToTrackActive, activePage }) {
// Create an array with page numbers
    const pages = Array.from({ length: numberOfPages }, (_, i) => i + 1);
    return (
        <Pagination size="lg">
        {pages.map((number) => (
            <Pagination.Item key={number} active={number === activePage} onClick={() => methodToTrackActive(number)}>
            {number}
            </Pagination.Item>
        ))}
        </Pagination>
    );
}

export default BuildPagination;